import * as math from 'mathjs';
import { sanitizeExpression } from '../sanitizeExpression';

// Funkcja wykładnicza: stała podstawa (liczba lub ułamek w nawiasie) podniesiona
// do wykładnika zawierającego x, np. 3^x, 3^(x-3), (1/2)^x.
export function detectExponentialFunction(rhs) {
  const clean = String(rhs || '').replace(/\s+/g, '');
  return /(?:\d+(?:\.\d+)?|\([^()]*\))\^\(?[^()=]*x/i.test(clean);
}

function evalReal(fn, x) {
  try {
    const v = fn.evaluate({ x });
    return typeof v === 'number' && Number.isFinite(v) ? v : NaN;
  } catch {
    return NaN;
  }
}

// Pozioma asymptota = granica w nieskończoności po stronie, gdzie człon
// wykładniczy zanika (zostaje stałe przesunięcie). Zwraca null, gdy brak.
export function computeHorizontalAsymptote(rhs, xMin, xMax) {
  let fn;
  try { fn = math.compile(sanitizeExpression(rhs)); } catch { return null; }
  const span = Math.max(20, xMax - xMin);
  const fLeft = evalReal(fn, xMin - span * 40);
  const fRight = evalReal(fn, xMax + span * 40);
  const round = (v) => Math.round(v * 1e6) / 1e6;
  const okL = Number.isFinite(fLeft);
  const okR = Number.isFinite(fRight);
  if (okL && !okR) return round(fLeft);
  if (okR && !okL) return round(fRight);
  if (okL && okR && Math.abs(fLeft - fRight) < 1e-6) return round(fLeft);
  return null;
}
